export default __webpack_public_path__ + "static/media/dashboard.dc081169.svg";